(function () {
  function getVideo(modal) {
    return modal.querySelector('.modal-video__video video, deferred-media video');
  }

  function enterFullscreen(video) {
    if (!video) return;
    if (video.requestFullscreen) {
      video.requestFullscreen().catch(function () {});
    } else if (video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-spite-manifesto-fullscreen]');
    if (!btn) return;
    var modal = btn.closest('modal-dialog.spite-manifesto__video-modal');
    if (!modal) return;
    enterFullscreen(getVideo(modal));
  });
})();
